import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-image',
  templateUrl: './delete-image.component.html',
  styleUrls: ['./delete-image.component.scss']
})
export class DeleteImageComponent implements OnInit {
  public popupImage;
  deleteIndex;
  fieldArray;
  title = '';
  filedValueLength:any;
  public modalOpen: boolean;
  message = "";
  constructor(
    public activeModal: NgbActiveModal,
  ) { }
  ngOnInit() {

  }
  switchTeam() {
    this.activeModal.dismiss();
  }

  close() {
    this.activeModal.dismiss();
  }

  deleteimage(): void {
    if (this.deleteIndex !== -1) {
      if(this.popupImage){
        this.popupImage.splice(this.deleteIndex, 1);
        this.activeModal.dismiss();
      }      
      if(this.fieldArray){
        this.fieldArray.splice(this.deleteIndex,1);
        this.activeModal.dismiss();
        if(this.fieldArray.length === 0){
          this.filedValueLength(this.fieldArray);
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/delete-image/delete-image.component.ts